import axios from 'axios';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8081';
const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
};
const api = axios.create({
    baseURL: API_BASE_URL || "",
});

// Always send uid header (your backend expects @RequestHeader("uid"))
export function setUid(uid) {
    api.defaults.headers.common["uid"] = String(uid);
}

export const leaveApi = {
    create: (payload) => api.post("/api/leave-requests/requests", payload).then((r) => r.data),

    mine: () => api.get("/api/leave-requests/requests/mine").then((r) => r.data),

    managerInbox: () => api.get("/api/leave-requests/manager/inbox").then((r) => r.data),

    adminInbox: () => api.get("/api/leave-requests/admin/inbox").then((r) => r.data),

    managerDecision: (id, decision) =>
        api.post(`/api/leave-requests/manager/requests/${id}/decision`, decision).then((r) => r.data),

    adminDecision: (id, decision) =>
        api.post(`/api/leave-requests/admin/requests/${id}/decision`, decision).then((r) => r.data),
};

const isFormData = (v) =>
    typeof FormData !== "undefined" && v instanceof FormData;

const getHeaders = (token, data) => {
    const base = {
        Accept: "application/json",
        uid: sessionStorage.getItem("uid"),
        Authorization: token,
        "X-Tenant-Id": sessionStorage.getItem("selectedCompanyId"),
    };

    // ✅ si FormData => ne PAS forcer Content-Type
    if (isFormData(data)) return base;

    return {
        ...base,
        "Content-Type": "application/json",
    };
};

// const getHeaders = (token) => {
//     return {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json',
//         'uid': sessionStorage.getItem('uid'),
//         'Authorization': token,
//         'X-Tenant-Id': sessionStorage.getItem('selectedCompanyId'), // 👈 clé
//
//     };
// };

//=====  POUR LES FICIHERS=====
export const getBlobRequest = async ({ url, token, extraHeaders = {} }) => {
    return axios.get(url, {
        responseType: "blob",

        headers: { Authorization: `Bearer ${token}`, ...extraHeaders },

    });
};

// ===== INTERCEPTOR: Requête =====
axios.interceptors.request.use(
    (config) => {
        console.log(`📤 [${config.method.toUpperCase()}] ${config.url}`);
        console.log('📦 Data:', config.data);
        return config;
    },
    (error) => {
        console.error('❌ Erreur requête:', error);
        return Promise.reject(error);
    }
);

// ===== INTERCEPTOR: Réponse =====
axios.interceptors.response.use(
    (response) => {
        console.log(`✅ [${response.status}] Réponse reçue:`, response.data);
        return response;
    },
    (error) => {
        console.group('❌ ERREUR RÉPONSE');
        console.error('Status:', error.response?.status);
        console.error('Message:', error.message);
        console.error('Data:', error.response?.data);
        console.error('Erreur complète:', error);
        console.groupEnd();
        return Promise.reject(error);
    }
);

export const apiSignup = (username, email, roles, password) => {
    console.log('🔵 apiSignup appelée');
    return axios.post(
        `${API_BASE_URL}/auth/signup`,
        { username, email, role: roles, password },
        { headers },
    );
};

export const apiSignin = (usernameOrEmail, password) => {
    console.log('🔵 apiSignin appelée');
    console.log('📧 Email/Username:', usernameOrEmail);

    return axios.post(
        `${API_BASE_URL}/api/auth/login`,
        { usernameOrEmail, password },
        { headers },
    );
};

export const getRequest = (data) => {
    const headers = getHeaders(`Bearer ${data.token}`);
    return axios.get(data.url, { headers });
};
export const getRequestForPdf = ({ url, token, headers = {}, responseType = "json" }) =>
    axios.get(url, {
        headers: { Authorization: `Bearer ${token}`, ...headers },
        responseType,
        transformResponse: [(d) => d],
    });


// export const postRequest = (data) => {
//     const headers = getHeaders(`Bearer ${data.token}`);
//     return axios.post(data.url, data.data, { headers });
// };
//
// export const putRequest = (data) => {
//     const headers = getHeaders(`Bearer ${data.token}`);
//     return axios.put(data.url, data.data, { headers });
// };

export const deleteRequest = (data) => {
    const headers = getHeaders(`Bearer ${data.token}`);
    return axios.delete(data.url, { headers });
};


export const postRequest = (data) => {
    const headers = getHeaders(`Bearer ${data.token}`, data.data);
    return axios.post(data.url, data.data, { headers });
};

export const putRequest = (data) => {
    const headers = getHeaders(`Bearer ${data.token}`, data.data);
    return axios.put(data.url, data.data, { headers });
};
export const patchRequest = ({ url, data, uid, token }) =>
    axios.patch(url, data, { headers: { uid, Authorization: `Bearer ${token}` } });

export const extractErrorMessage = (error, fallback) => {
    const data = error?.response?.data;

    if (data?.message) return String(data.message);
    if (data?.error) return String(data.error);
    if (error?.message) return String(error.message);

    try {
        if (data && typeof data === "object") return JSON.stringify(data);
    } catch {}
    return fallback;
};

export const notificationSettingsApi = {
    getAll: (data) => getRequest({ url: `${API_BASE_URL}/api/notification-settings`, token: data.token }),
    create: (data) => postRequest({ url: `${API_BASE_URL}/api/notification-settings`, data: data.data, token: data.token }),
    update: (data) => putRequest({ url: `${API_BASE_URL}/api/notification-settings/${data.id}`, data: data.data, token: data.token }),
    delete: (data) => deleteRequest({ url: `${API_BASE_URL}/api/notification-settings/${data.id}`, token: data.token }),
    getByEvent: (data) => getRequest({ url: `${API_BASE_URL}/api/notification-settings/event/${data.eventCode}`, token: data.token }),
};

const buildNotificationQuery = (data) => {
    const params = [];
    if (data.roleId) params.push(`roleId=${encodeURIComponent(data.roleId)}`);
    if (data.moduleId) params.push(`moduleId=${encodeURIComponent(data.moduleId)}`);
    return params.length ? `?${params.join('&')}` : '';
};

export const notificationApi = {
    getUnread: (data) => getRequest({ url: `${API_BASE_URL}/api/notifications/user/${data.userId}/unread${buildNotificationQuery(data)}`, token: data.token }),
    getRecent: (data) => getRequest({ url: `${API_BASE_URL}/api/notifications/user/${data.userId}${buildNotificationQuery(data)}`, token: data.token }),
    getCount: (data) => getRequest({ url: `${API_BASE_URL}/api/notifications/user/${data.userId}/count-unread${buildNotificationQuery(data)}`, token: data.token }),
    markRead: (data) => patchRequest({ url: `${API_BASE_URL}/api/notifications/${data.id}/read`, token: data.token }),
    markAllRead: (data) => patchRequest({ url: `${API_BASE_URL}/api/notifications/user/${data.userId}/read-all${buildNotificationQuery(data)}`, token: data.token })
};
